// @ts-nocheck
import { Icon } from '@iconify/react';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
// material
import { useTheme, styled } from '@mui/material/styles';
import { Box, Paper, Stack, Card, Button, Collapse, TextField, IconButton, Typography, GridLegacy as Grid  } from '@mui/material';
import plusFill from '@iconify/icons-eva/plus-fill';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useEffect, useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';

import Page from '../../../../../components/Page';
import LightboxModal from '../../../../../components/LightboxModal';
import { doc400 } from '../../../../userImage';
import DocPreview, { LoadingPreview } from './DocPreview';
import DocUploadDropzone from './DocUploadDropzone';
import { FDate } from 'src/constants/defaultValues';


// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function VerifyCode({doc, toast, isMobile, editable, handleUpdateDoc,handleAddDoc,loading}) {

  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  let [provider, setProvider] = useState('');
  let [expiryDate, setExpiryDate] = useState('');
  let [policyNumber, setPolicyNumber] = useState('');
  let [file, setFile] = useState(null);
  let [fileId, setFileId] = useState(null);
  let   [currentFile, setCurrentFile] = useState(null);
  let   [fileOpen, setFileOpen] = useState(false);

  // let [cards, setCards] = useState([]);



  useEffect(()=>{
    // console.log('got job data: ',jobdata);
    if(doc && doc.id){
      if(doc.provider) setProvider(doc.provider)
      if(doc.expiry_date) setExpiryDate(doc.expiry_date)
      if(doc.policy_number) setPolicyNumber(doc.policy_number)
    }

  },[doc]);

  // const handleSubmit = e=>{

  //   if(cards.length>0){
  //     handleLicenses(cards);
  //   }else{
  //     toast('warning', 'Please add at least one card!')
  //   }
  // }

  const handleSubmit = e=>{
      if(expiryDate){
		  if(expiryDate=='Invalid Date'){
			toast('warning', 'Please select a valid expiry date');
			return;
		}
        let insurance = {
          // provider,
          expiry_date: new Date(expiryDate).toISOString().split('T')[0],
          // policy_number: policyNumber
        };
        if(fileId){
          insurance.fileId = fileId;
        }

        if(doc && doc.id){
          handleUpdateDoc(insurance);
        }else{
          if(!insurance.fileId){
            toast('warning',"Please upload the copy of the card!");
            return;
          }
          handleAddDoc(insurance);
        }


      }else{
        toast('warning', 'Please fill all the fields!')
      }


  }

  const handleViewDoc = doc=>{
    setCurrentFile(doc.file);
    setFileOpen(true);
  }

  const stackStyle = {};
  if(isMobile){
    stackStyle.maxHeight = '90vh';
    stackStyle.overflowY = 'auto';
  }

  return (
    <div style={stackStyle}>
      <Stack spacing={2} direction={{ xs: 'column', md: 'row' }}>
          <Paper
            sx={{
              p: 2,
              width: 1,
              position: 'relative',
              border: (theme) => `solid 1px ${theme.palette.grey[500_32]}`,
            }}
            style={{paddingRight: '40px'}}
          >

        <Grid container spacing={3} sx={{ mb: 2 }}>
          {/* <Grid item xs={6} >
            <Box
              component="form"
              noValidate
              autoComplete="off"
            >
              {
                  editable?(
                      <TextField id="b-card-name" value={provider} onChange={e=>setProvider(e.target.value)} label="Insurance Provider" variant="outlined" />
                  ):(
                      <Typography sx={{borderBottom: `solid 1px ${theme.palette.grey[500_32]}`}}> {provider}</Typography>
                  )
              }

            </Box>




          </Grid> */}
          <Grid item xs={6} >
              {
                editable?(
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker format="dd-MM-yyyy" 
                      label="Expiry Date"
                      value={expiryDate}
                      openTo="day"
                      views={['day','month','year']}
                      onChange={(newValue) => {
                        setExpiryDate(newValue);
                      }}
                    />
                  </LocalizationProvider>
                ):(
                    <Typography sx={{borderBottom: `solid 1px ${theme.palette.grey[500_32]}`}}> {FDate(expiryDate)}</Typography>
                )
              }


            </Grid>

          <Grid item xs={4} >
            <Box
                component="img"
                alt="icon"
                src={`/static/icons/WC-logo-${isLight ? 'light' : 'dark'}.png`}
                loading="lazy"
                decoding="async"
            />


          </Grid>
        </Grid>

        {/* <Grid container spacing={3} sx={{ mb: 2 }}>
          <Grid item xs={6} >
            <Box
              component="form"
              noValidate
              autoComplete="off"
            >
              {
                  editable?(
                    <TextField value={policyNumber} onChange={e=>setPolicyNumber(e.target.value)} id="qbcc-n" label="Policy Number" variant="outlined" />
                  ):(
                      <Typography sx={{borderBottom: `solid 1px ${theme.palette.grey[500_32]}`}}> {policyNumber}</Typography>
                  )
              }

            </Box>
          </Grid>

          <Grid item xs={6} >
              {
                editable?(
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker format="dd-MM-yyyy" 
                      label="Expiry Date"
                      value={expiryDate}
                      openTo="day"
                      views={['day','month','year']}
                      onChange={(newValue) => {
                        setExpiryDate(newValue);
                      }}
                    />
                  </LocalizationProvider>
                ):(
                    <Typography sx={{borderBottom: `solid 1px ${theme.palette.grey[500_32]}`}}> {FDate(expiryDate)}</Typography>
                )
              }


            </Grid>
        </Grid> */}

        {
          editable?(
            <Box sx={{ mt: 1 }}>
              <DocUploadDropzone
                label="Upload Work Cover Copy"
                file={file || doc?.file}
                toast={toast}
                onUploaded={(res)=>{ setFileId(res.fileId); setFile(res.url); }}
              />
            </Box>
          ):null
        }



            <Typography variant="subtitle2"> </Typography>
          </Paper>

      </Stack>
      {
            editable?(
              <LoadingButton fullWidth variant="contained" loading={loading} disabled={!file && !doc?.file} sx={{mt:2}} onClick={handleSubmit}> {doc?.id ? 'Save changes' : 'Upload'} </LoadingButton>
            ): <DocPreview file={doc.file} />
        }
    </div>
  );
}